import { toastr } from 'react-redux-toastr';
import {
    pendingTask, // The action key for modifying loading state
    begin, // The action value if a "long" running task begun
    end, // The action value if a "long" running task ended
} from 'react-redux-spinner';
import { UPDATE_ADMIN_APP_DATA } from './appData.actions';
import { LOADING_START, LOADING_END } from '../../../store/loading';
import {
    getAllSetup,
    getAllMyPublicHyperfinds,
    getAllDataview,
    getGenericNotificationList,
    getAllAwardingRules,
    getAllCustomDateFormat,
    getNotificationTagList,
} from '../../services/api-endpoints';
import { 
    getScheduleSourceLabel, 
    getAutoApprovalLabel, 
    getBidProcessTypeLabel
} from '../../../Enums/Helpers/LabellingHelper';

// eslint-disable-next-line import/prefer-default-export
export const fetchAdminAppData = () => /** @param {import('redux').Dispatch} dispatch */async (dispatch) => {
    dispatch({ type: LOADING_START, [pendingTask]: begin });
    try {
        const [
            hyperfindsResponse,
            setupsResponse,
            dataviewsResponse,
            notificationsResponse,
            awardingRulesResponse,
            customDateFormatResponse,
        ] = await Promise.all([
            getAllMyPublicHyperfinds(),
            getAllSetup(),
            getAllDataview(),
            getGenericNotificationList(),
            getAllAwardingRules(),
            getAllCustomDateFormat(),
        ]);

        const hyperfindDictionary = Object.assign({}, ...hyperfindsResponse.data.map((x) => ({ [x.value]: x.label })));
        const parsedSetupsResponse = setupsResponse.data.map((setup) => ({
            ...setup,
            // hyperfindName: hyperfindsResponse.data.find((hyperfind) => hyperfind.value === setup.hyperfindId)?.label,
            autoApprovalName: getAutoApprovalLabel(setup.isAutoApproval),
            scheduleSourceName: getScheduleSourceLabel(setup.scheduleSource),
            creationHyperfindName: setup.creationHyperfindId ? hyperfindDictionary[setup.creationHyperfindId] : '',
            managementHyperfindName: setup.managementHyperfindId ? hyperfindDictionary[setup.managementHyperfindId] : '',
            viewHyperfindName: setup.viewHyperfindId ? hyperfindDictionary[setup.viewHyperfindId] : '',
            bidProcessTypeName: getBidProcessTypeLabel(setup.bidProcessType),
        }));

        const notifTemplatesWithNone = [{ id: 'none', name: 'None' }, ...notificationsResponse.data];

        /**
         * @param {ApiAdmin.IAwardingParametersPresentationModel[]} parameters
         * @returns {AwardingRule.IDataviewAwardingParameter[]}
         */
        const parseParameters = (parameters) => parameters.sort((x, y) => x.orderNumber - y.orderNumber).map((p) => ({
            sortOrderType: p.sortOrderType,
            dataviewKeyAlias: p.dataviewKeyAlias,
            dataType: p.dataType,
            customDateFormatId: p.customDateFormatId,
        }));

        const parsedAwardingRules = awardingRulesResponse.data.map((x) => ({
            ...x,
            parameters: parseParameters(x.parameters),
        }));

        dispatch({
            type: UPDATE_ADMIN_APP_DATA,
            payload: {
                hyperfinds: hyperfindsResponse.data,
                setups: parsedSetupsResponse,
                dataviews: dataviewsResponse.data,
                genericNotificationTemplates: notifTemplatesWithNone,
                awardingRules: parsedAwardingRules,
                isAdminAppDataLoaded: true,
                customDateFormat: customDateFormatResponse.data,
            },
        });
    } catch (error) {
        toastr.error('Loading app data', error.response.data.Message);
    } finally {
        dispatch({ type: LOADING_END, [pendingTask]: end });
    }
};

// eslint-disable-next-line import/prefer-default-export
export const displayNotificationCustomTags = () => /** @param {import('redux').Dispatch} dispatch */async (dispatch) => {
    dispatch({ type: LOADING_START, [pendingTask]: begin });
    try {
        const response = await getNotificationTagList();

        if (response.status === 200) {
            dispatch({
                type: UPDATE_ADMIN_APP_DATA,
                payload: {
                    notificationCustomTags: response.data,
                },
            });
        } else {
            toastr.error('Loading custom tags', 'Failed to load');
        }
    } catch (error) {
        toastr.error('Loading custom tags', error.response.data.Message);
    } finally {
        dispatch({ type: LOADING_END, [pendingTask]: end });
    }
};
